<template>
  <div class="container">
    <!-- 头部区域 -->
    <div class="header">
      <!-- 引用header组件 -->
      <Header class="head"></Header>
      <!-- 内容区域 -->
      <div class="header-content">
        <div class="banner-content">
          <!-- 标题 -->
          <div class="banner-first-title">
            智慧农贸解决方案
          </div>
          <!-- 副标题 -->
          <div class="banner-second-title">
            {{ bannerSecond }}
          </div>
          <!-- 申请试用 -->
          <Apply :inputName="tit" :type="type" class="applybtn"></Apply>
        </div>
        <!-- 图片,用作flex占位 -->
        <div class="banner-img"></div>
      </div>
    </div>
    <!-- 正文 -->
    <div class="content">
      <div class="item" v-for="(item, index) in titleList" :key="index">
        <!-- 标题 -->
        <div class="item-tit">
          <!-- 一级 -->
          <div class="first-tit">
            <img :src="item.img" alt="" />
          </div>
          <!-- 二级 -->
          <div class="second-tit">
            {{ item.intro }}
          </div>
        </div>
        <!-- 内容 -->
        <div class="item-content">
          <!-- 根据index，区分item内容区域 -->
          <div v-if="index === 0" class="weigh">
            <!-- 视频区域 -->
            <div class="video-content">
              <!-- 左侧视频 -->
              <Video :mp="mp" :poster="poster" class="video"></Video>
              <!-- 右侧标识 -->
              <div class="video-right">
                <el-collapse v-model="activeName" accordion>
                  <div
                    v-for="(item, index) in avantList"
                    :key="index"
                    @mouseover="mouseover(index)"
                  >
                    <el-collapse-item :title="item.name" :name="index">
                      <ul>
                        <li
                          v-for="(item2, index2) in item.children"
                          :key="index2"
                        >
                          {{ item2 }}
                        </li>
                      </ul>
                    </el-collapse-item>
                  </div>
                </el-collapse>
              </div>
            </div>
          </div>
          <div v-if="index === 1" class="ai" id="hello">
            <transition name="el-zoom-in-center">
              <div v-show="show1" class="transition-box">
                <img src="../assets/img/newMarket/ai.png" alt="" width="100%" />
              </div>
            </transition>
          </div>
          <div v-if="index === 2" class="public">
            <div class="product-content">
              <el-carousel :interval="4000" type="card" height="500px">
                <el-carousel-item
                  v-for="(item, index) in publicList"
                  :key="index"
                >
                  <img :src="item.img" alt="" width="100%" />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div v-if="index === 3" class="goodtest">
            <transition name="el-zoom-in-bottom">
              <div v-show="show2" class="transition-box">
                <img src="../assets/img/newMarket/goodtest.jpg" alt="" />
              </div>
            </transition>
          </div>
          <div v-if="index === 4" class="air">
            <div class="air-item" v-for="(item, index) in airList" :key="index">
              <div>
                <img :src="item.img" alt="" />
              </div>
              <div class="air-name">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div v-if="index === 5" class="big-data">
            <!-- 左侧 -->
            <div class="big-left">
              <div
                class="img"
                v-for="(item, index) in bigLeftList"
                :key="index"
              >
                <div class="img-name">
                  {{ item.name }}
                </div>
                <transition name="el-zoom-in-left">
                  <div v-show="show3" class="transition-box">
                    <img :src="item.img" alt="" />
                  </div>
                </transition>
              </div>
            </div>
            <!-- 右侧 -->
            <div class="big-right">
              <div
                class="img"
                v-for="(item, index) in bigRightList"
                :key="index"
              >
                <div class="img-name">
                  {{ item.name }}
                </div>
                <transition name="el-zoom-in-left">
                  <div v-show="show3" class="transition-box">
                    <img :src="item.img" alt="" />
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 线上商城 -->
      <div class="shop">
        <!-- 文案 -->
        <div class="shop-tit">
          <transition name="el-fade-in-linear">
            <div v-show="show4" class="transition-box">
              <img src="../assets/img/newMarket/shop.jpg" alt="" />
            </div>
          </transition>
        </div>
      </div>
      <!-- 服务 -->
      <Serve></Serve>
      <!-- 解决方案 -->
      <Solution :inputName="apply" :type="type"></Solution>
    </div>
  </div>
</template>

<script>
// 引用申请试用和头部组件
import Apply from '../components/apply.vue'
import Header from '../components/header.vue'
import Video from '../components/video.vue'
import Serve from '../components/serve.vue'
import Solution from '../components/solution.vue'
export default {
  components: {
    Apply,
    Header,
    Video,
    Serve,
    Solution
  },
  data() {
    return {
      bannerSecond:
        '利用先进的信息化手段，在实现关注食品安全，保护消费者权益、方便消费购物的同时，提升市场管理水平，实现菜市场运营管理、网上菜场、市场监管等三大平台功能，海量异构数据统一分析处理与展示。',
      tit: '方案咨询',
      apply: '智慧农贸解决方案',
      // 标题列表
      titleList: [
        {
          img: require('../assets/img/newMarket/01.png'),
          intro:
            '实现智能称重、收银，可打印溯源票据，此外，还搭载智能AI识别功能快速识别秤盘上的商品，便于商户操作'
        },
        {
          img: require('../assets/img/newMarket/02.png'),
          intro:
            '基于物联传感云平台，通过特定目标识别、频次分析、轨迹分析等人工智能（AI）技术，为农贸市场等业务场景提供核心技术支撑'
        },
        {
          img: require('../assets/img/newMarket/03.png'),
          intro:
            '公示商户证件信息、交易数据、信用等级、菜品价格等信息，提高市场消费者服务体验，实现农贸市场信息公开、透明，保证消费者合法权益'
        },
        {
          img: require('../assets/img/newMarket/04.png'),
          intro:
            '可检测蔬菜水果农残、食用油、肉类、水产品、食品添加剂、食品重金属等200余项检测。数据通过互联网进行数据上传，检测结果直接传至监管平台，进行区域食品安全监管及大数据分析处理，检测食品安全长短期动态，达到食品安全问题预估、预警'
        },
        {
          img: require('../assets/img/newMarket/05.png'),
          intro:
            '内置空气质量监测仪、智能AI摄像探测仪，监测市场内空气质量变化，实时监控'
        },
        {
          img: require('../assets/img/newMarket/06.png'),
          intro:
            '在商户信息公示屏和市场信息查询触摸屏对商户证件信息、溯源信息、菜品价格等信息进行公示，实现农贸市场信息公开、透明'
        }
      ],
      // 溯源系统
      avantList: [
        {
          name: 'AI识物',
          children: [
            '果蔬精准识别',
            '自学习算法不断优化',
            '容器过滤、包装过滤',
            '模糊识别大数据筛选'
          ]
        },
        {
          name: '操作便捷',
          children: ['轻松改价', '整单折扣', '一键出票', '操作难度低、易上手']
        },
        {
          name: '智能收银',
          children: ['聚合支付', '快速扫码', '溯源信息']
        },
        {
          name: '对接小程序',
          children: [
            '快速上下架',
            '数据统一',
            '订货商城',
            '分析数据',
            '扫码溯源'
          ]
        }
      ],
      activeName: 0,
      // 大数据
      bigLeftList: [
        {
          name: '运营管理平台PC端',
          img: require('../assets/img/newMarket/bigdata/01.jpg')
        },
        {
          name: '线上商城小程序',
          img: require('../assets/img/newMarket/bigdata/02.jpg')
        },
        {
          name: '数据可视化大屏',
          img: require('../assets/img/newMarket/bigdata/03.jpg')
        }
      ],
      bigRightList: [
        {
          name: '市场监管平台',
          img: require('../assets/img/newMarket/bigdata/04.jpg')
        },
        {
          name: '商家端小程序',
          img: require('../assets/img/newMarket/bigdata/05.jpg')
        },
        {
          name: '导购屏',
          img: require('../assets/img/newMarket/bigdata/06.jpg')
        }
      ],
      shopTitle: '线上商城电商平台',
      shopDetail:
        '线上商场采用B2C和O2O的模式，将菜市场店铺商品搬到线上平台，贴合用户在生活买菜上的需求，一键购买，实时配送，享受送货到家的服务。',
      airList: [
        {
          name: '温度',
          img: require('../assets/img/newMarket/test/01.png')
        },
        {
          name: '湿度',
          img: require('../assets/img/newMarket/test/02.png')
        },
        {
          name: 'PM10',
          img: require('../assets/img/newMarket/test/03.png')
        },
        {
          name: '甲醛',
          img: require('../assets/img/newMarket/test/04.png')
        },
        {
          name: 'CO2',
          img: require('../assets/img/newMarket/test/05.png')
        },
        {
          name: 'PM2.5',
          img: require('../assets/img/newMarket/test/06.png')
        },
        {
          name: 'TVOC',
          img: require('../assets/img/newMarket/test/07.png')
        }
      ],
      // 公示
      publicList: [
        {
          img: require('../assets/img/newMarket/public/06.jpg')
        },
        {
          img: require('../assets/img/newMarket/public/04.jpg')
        },
        {
          img: require('../assets/img/newMarket/public/05.jpg')
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      mp:
        'https://file.agricultural.fameveg.com/file/upload/web/2021-07-22/4e73536c770a4bc5a23e28cd8c1292ca.mp4',
      poster:
        'https://file.agricultural.fameveg.com/file/upload/null/2021-07-22/3fa70c23320042b99f93722c58d2ddd3.png',
      type: '2'
    }
  },
  methods: {
    // 鼠标移动在哪里，哪里展开
    mouseover(index) {
      this.activeName = index
    },
    // 计算滚动距离
    showIcon() {
      // if (
      //   !!document.documentElement.scrollTop &&
      //   document.documentElement.scrollTop > 1200
      // ) {
      //   this.show = true
      // } else {
      //   this.show = false
      // }
    },
    // 滚动高度
    handleScroll() {
      const top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop // 兼容不同的浏览器
      if (top > 100) {
        // this.show1 = true
      }
      if (top > 2000) {
        this.show2 = true
      }
      if (top > 2100) {
        this.show3 = true
      }
      if (top > 2800) {
        this.show4 = true
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听滚动事件
  }
}
</script>

<style lang="less">
.container {
  height: 100%;
  background-color: #f5f5f5;
}
// 头部区域
.header {
  height: 800px;
  width: 100%;
  background: url(../assets/img/newMarket/banner.jpg) center no-repeat;
  // background-size: 100% 100%;
  background-size: cover;
  color: #fff;
  font-size: 22px;
  .header-content {
    display: flex;
    justify-content: center;
    .banner-content {
      width: 800px;
      color: #ffffff;
      padding: 43px;
      .banner-first-title {
        margin-top: 70px;
        font-size: 50px;
      }
      .banner-second-title {
        margin-top: 50px;
        font-size: 22px;
        margin-bottom: 60px;
        width: 500px;
      }
      .applybtn {
        position: relative;
        top: 50px;
        left: -150px;
      }
    }
    .banner-img {
      width: 600px;
    }
  }
}
.content {
  .item {
    .item-tit {
      width: 1300px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 318px;
      .second-tit {
        margin-top: 30px;
        font-size: 20px;
        font-weight: 300;
        color: #999999;
      }
    }
    .item-content {
      .weigh {
        width: 100%;
        height: 600px;
        background-color: #fff;
        .video-content {
          width: 1300px;
          height: 600px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          .video-right {
            margin-left: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            .el-collapse {
              width: 400px;
            }
            .el-collapse-item__wrap,
            .el-collapse-item__header.is-active {
              padding: 10px;
              background: #000000;
              opacity: 0.3;
              color: #fff;
              li {
                color: #fff;
              }
            }
            .el-collapse-item__header {
              font-size: 26px;
              color: #999;
            }
            li {
              font-size: 16px;
              color: #999;
            }
          }
        }
      }
      // ai
      .ai {
        width: 100%;
        height: 1225px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      // 食安检测
      .goodtest {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      // 空气
      .air {
        width: 1300px;
        margin: 0 auto;
        display: flex;
        .air-item {
          width: 200px;
          height: 220px;
          display: flex;
          flex-direction: column;
          margin: 0 20px;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          font-weight: 300;
          color: #666666;
          border-radius: 10px;
          background-color: #fff;
          .air-name {
            margin-top: 44px;
          }
        }
        .air-item:hover {
          font-size: 26px;
        }
      }
      // 大数据
      .big-data {
        width: 1300px;
        margin: 0 auto;
        display: flex;
        .big-left,
        .big-right {
          .img {
            .img-name {
              width: 180px;
              height: 50px;
              background: #000000;
              opacity: 0.5;
              border-radius: 25px;
              font-size: 18px;
              font-weight: 300;
              color: #ffffff;
              position: relative;
              left: 20px;
              top: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            img {
              margin: -15px 10px;
            }
          }
          .img:hover {
            .img-name {
              background-color: #ff8f11;
              opacity: 0.6;
              font-size: 20px;
            }
          }
        }
      }
    }
  }
  // 电商
  .shop {
    margin-top: 50px;
    width: 100%;
    .shop-tit {
      img {
        width: 100%;
      }
    }
  }
}
</style>
